export default {
  pagesTitle:
    "Excoino | Currency | Excoino official website - global bitcoin trading platform | Global digital currency trading platform",
  loginTip: "Please login first",
  searchPlaceHolder: "Search...",
  logout: "Logout",
  tip: "Important Tips:",
  nodata: "No data recorded",
  more: "All",
  please: "Please",
  pleaseSelect: "Select",
  loadingText: "Loading results, please wait",
  getRealized: "Got it",
  excoino: "Excoino",
  messages: "Messages",
  noMessage: "You have no messages",
  searchNameCoin: "Search by currency name or abbreviation...",
  show: "Show",
  removeFilter: "Remove Filter",
  showAllCoins: "Show All Coins",
  day: "day",
  Withdrawal: "Withdrawal",
  Return: "Return",
  Enable: "Enable",
  Disable: "Disable",
  Time: "Time",
  Reward: "Reward",
  Date: "Date",
  free: "Free",
  from: "From",
  until: "Until",
  until_2: "Until",
  TERMINATED: "Terminated",
  IN_PROGRESS: "In Progress",
  ACTIVATE: "Active",
  DISABLED: "Disabled",
  registrationClosed: "Registration Closed"
};
